import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('../views/Login/Login');
const Student = () => import('../views/Login/student/Student');
const Teacher = () => import('../views/Login/teacher/Teacher');
const Admin = () => import('../views/Login/admin/Admin');

const Home = () => import('../views/Home/Home');

const Course = () => import('../views/Course/Course');
const CourseList = () => import('../views/Course/CourseList/CourseList');
const AddCourse = () => import('../views/Course/AddCourse/AddCourse');
const LookStudent = () => import('../views/Course/LookStudent/LookStudent');

const Teachers = () => import('../views/Teacher/Teacher');
const Tealist = () => import('../views/Teacher/Tealist/TeaList');
const Addtea = () => import('../views/Teacher/AddTeacher/Addteacher');


const Select = () => import('../views/Select/Select');
const SelectList = () => import('../views/Select/SelectList/SelectList');

const Profile = () => import('../views/Profile/Profile');
const StuProfile = () => import('../views/StuProfile/StuProfile');

import store from 'store';

import login from "./login";
import course from "./course";
import select from "./select";
import teacher from "./teacher";
import student from "@/router/student";
import Club from "./club";
import ClubSelect from "@/router/club_select";
import venue_manage from "@/router/venue_manage";
import venue_select from "@/router/venue_select";
import news from "@/router/news";
import Test_booking_m from "@/router/physical_test/test_booking_manage";
import physical_test from "@/router/physical_test/physical_test";

Vue.use(VueRouter);

const routes = [
  ...login,
  ...course,
  ...select,
  ...teacher,
  ...student,
  ...Club,
  ...ClubSelect,
  ...venue_manage,
  ...venue_select,
  ...news,
  ...Test_booking_m,
  ...physical_test,
  {
    path: '',
    redirect: '/login'
  },
  {
    path: "/home",
    component: () => import('../views/Home/Home'),
    meta: {
      title: '首页'
    },
  },
  {
    path: "/music",
    component: () => import('../views/Music/Music'),
    meta: {
      title: '音乐'
    },
  },
  {
    path: "/profile",
    component: () => import('../views/Profile/Profile'),
    meta: {
      title: '个人'
    },
  },
  {
    path: "/stuprofile",
    component: () => import('../views/StuProfile/StuProfile'),
    meta: {
      title: '信息'
    },
  }, {
    path: "/more",
    component: () => import('../views/More/More'),
    meta: {
      title: '更多'
    },
  },
  {
    path: "/PhysicalTestQuery",
    component: () => import('../views/PhysicalTest/PhysicalTestQuery/PhysicalTestQuery'),
    meta: {
      title: '体测查询'
    },
  },
  {
    path: "/NoTestApply",
    component: () => import('../views/PhysicalTest/NoTestApply/NoTestApply'),
    meta: {
      title: '免测申请'
    },
  }, {
    path: "/NoTestApplyList",
    component: () => import('../views/PhysicalTest/NoTestApplyList/NoTestApplyList'),
    meta: {
      title: '免测申请列表'
    },
  }, {
    path: "/SportsMeet",
    component: () => import('../views/SportsMeet/SportsMeet'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '运动会管理'
    },
  }, {
    path: "/SportsMeetSerial",
    component: () => import('../views/SportsMeet/SportsMeetSerial'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '运动会序号管理'
    },
  }, {
    path: "/CampusActivities",
    component: () => import('../views/CampusActivities/CampusActivities'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '校园体育活动'
    },

  },
  {
    path: '/CampusActivitiesMember',
    component: () => import('../views/CampusActivitiesMember/CampusActivitiesMember'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/CampusActivities");
    },
    meta: {
      title: '校园体育活动成员'
    },
  },
  {
    path: "/AddCampusActivities",
    component: () => import('../views/AddCampusActivities/AddCampusActivities'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/CampusActivities");
    },
    meta: {
      title: '校园体育活动添加'
    },
  }, {
    path: "/DataCenter",
    component: () => import('../views/DataCenter/DataCenter'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") == "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '数据可视化'
    },
  }
];

const router = new VueRouter({
  mode: 'history',
  //mode: 'hash',
  // base: process.env.BASE_URL,

  routes
});
//全局导航守卫
//前置守卫(guard),跳转前回调
router.beforeEach((to, from, next) => {
  //设置的跟随主组件标题
  // document.title=to.matched[0].meta.title;
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }

  if (to.fullPath.indexOf("login") != -1) {
    document.title = to.meta.title;
    next();
    return;
  } else {
    if (router.app.$cookies.get("islogin")) {
      /**
       * 从from跳转到to
       * 设置路由跳转之后的对应标题
       */
      //可以设置单独组件嵌套的标题
      document.title = to.meta.title;
      //如果存在用户信息，或者进入的页面是登录页面，则直接进入
      next();
      return;
    } else {
      //不存在用户信息则说明用户未登录，跳转到登录页面，带上当前的页面地址，登录完成后做回跳，
      //如未登录用户进入用户中心的页面地址，检测到未登录，
      //自动跳转到登录页面，并且带上用户中心的页面地址，登录完成后重新跳到个人中心页面。

      //next('/login')
      router.replace("/login");
    }
  }

});
export default router


// if (to.fullPath.indexOf("login") != -1) {
//   document.title = to.meta.title;
//   next();
// }
// if (store.state.islogin === true) {
//   /**
//    * 从from跳转到to
//    * 设置路由跳转之后的对应标题
//    */
//   //可以设置单独组件嵌套的标题
//   document.title = to.meta.title;
//   //如果存在用户信息，或者进入的页面是登录页面，则直接进入
//   next()
// } else {
//   //不存在用户信息则说明用户未登录，跳转到登录页面，带上当前的页面地址，登录完成后做回跳，
//   //如未登录用户进入用户中心的页面地址，检测到未登录，
//   //自动跳转到登录页面，并且带上用户中心的页面地址，登录完成后重新跳到个人中心页面。
//   next('/login')
// }
